import React, { useState, useEffect } from "react";
import { ThemeContext, themes } from "../contexts/ThemeContext";
import useTheme from "../hooks/useTheme";
import { useRecoilValue } from "recoil";
import { settingsAtom } from "../state";

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState("light");
  const { theme } = useTheme();
  const settings = useRecoilValue(settingsAtom);

  useEffect(() => {
    const stored = settings?.theme?.toLowerCase() || "green"; //localStorage.getItem("theme");
    if (stored && themes[stored]) {
      setCurrentTheme(stored);
      applyTheme(stored);
    }
  }, [theme, settings]);

  const applyTheme = (themeName) => {
    // Remove all theme classes
    Object.keys(themes).forEach((theme) => {
      document.documentElement.classList.remove(`theme-${theme}`);
    });

    // Add new theme class
    document.documentElement.classList.add(`theme-${themeName}`);
  };

  const setTheme = (themeName) => {
    //console.log(themeName, "kjwbrjkvb");
    if (themes[themeName]) {
      setCurrentTheme(themeName);
      localStorage.setItem("theme", themeName);
      applyTheme(themeName);
    }
  };

  return (
    <ThemeContext.Provider value={{ currentTheme, setTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
};
